export default __webpack_public_path__ + "static/media/102.e01fb421.jpg";